import { render } from "./BootstrapRange.vue?vue&type=template&id=a5f3dfdc"
import script from "./BootstrapRange.vue?vue&type=script&lang=js"
export * from "./BootstrapRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__